// Export the built CSS as a string for components that need to inject styles
// Tailwind + web-components CSS is compiled into this file by our PostCSS pipeline
// esbuild-raw-plugin ensures importing CSS returns its raw contents as a string

import { css, LitElement, unsafeCSS } from 'lit'

import output from './styles.css?raw'

const style = css`
  ${unsafeCSS(output)}

  :host([is-inline]) {
    display: inline-flex;
    align-items: center;
  }

  :host([is-full-width]) {
    width: 100%;
    flex: 1;
    display: flex;
  }
`

export class CoreLitElement extends LitElement {
  static styles = [style]
}

export default style
